import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import NivoPie from "Components/Stats/Charts/NivoPie";
import Margin from "Components/Stats/Margin";
import { getCompaniesOffersData } from "Components/Stats/Data/Entreprises/Entreprises";

const CompaniesOffers = (props) => {
  const [companiesOffers, setCompaniesOffers] = useState([]);

  useEffect(() => {
    setCompaniesOffers(getCompaniesOffersData());
  }, []);

  return (
    <React.Fragment>
      <NivoPie
        data={companiesOffers}
        title={
          "Nombre d'offres par entreprise sur l'université " +
          props.universityName
        }
        displayPercentage
        colors="accent"
      />
      <Margin position="bottom" size="s" />
    </React.Fragment>
  );
};

CompaniesOffers.propTypes = {
  universityName: PropTypes.string,
};

export default CompaniesOffers;
